import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField } from '@mui/material';
const GetEmailPopup = ({ openDialog, setGetEmailId, onSubmit }) => {
 const [open, setOpen] = React.useState(false);
 const [emailId, setEmailId] = React.useState('')
 const [isValid, setIsValid] = React.useState(false)
 React.useEffect(() => { setOpen(openDialog) }, [openDialog])


 const handleClose = () => {
  setOpen(false);
 };
 const validateEmail = (data) => {
  return String(data)
   .toLowerCase()
   .match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
   );
 };

 const handleValidateEmail = () => {
  if (validateEmail(emailId)?.length) {
   onSubmit(emailId)
   setIsValid(false)
   setOpen(false)
  } else {
   setIsValid(true)
  }
 }
 return (
  <div className='createProjectPopup'>
   <Dialog
    open={open}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
   >
    <DialogTitle id="alert-dialog-title" className='text-center character_title pt-40  font-semibold'>

    </DialogTitle>
    <DialogContent >
     <DialogContentText id="alert-dialog-description">
      <div className='w-96 pb-3'>
       <p className='Email_pop_title pb-6'>Add Email Id</p>
       <p className='Email_pop_label'>Email:</p>
       <TextField
        margin="dense"
        id="name"
        type="email"
        fullWidth
        variant="standard"
        onChange={(e) => { setEmailId(e.target.value) }}
        helperText={isValid && 'please enter valid email address'}
        error={isValid}
       />
      </div>
     </DialogContentText>
    </DialogContent>
    <DialogActions className='createProject_button'>
     <div className='view_profile Email_pop_button m-0 pb-3'><Button variant="contained" onClick={() => handleValidateEmail()}>Submit</Button></div>
    </DialogActions>
   </Dialog>
  </div>
 )
}

export default GetEmailPopup